import type { OrganizationType } from "@bookdental/schemas";

export type DashboardMode = "office" | "lab" | "hybrid";

/** Mesma regra de `useQuickLinks` do Dashboard v1 (apps/app/src/routes/Dashboard.tsx) —
 *  híbrida mostra as duas visões, só lab mostra a de lab, qualquer outro caso (inclusive
 *  radiologia sozinha ou sem tipo) cai no padrão de clínica. */
export function resolveDashboardMode(types: OrganizationType[]): DashboardMode {
  const isClinic = types.includes("DENTAL_OFFICE");
  const isLab = types.includes("DENTAL_LAB");
  if (isClinic && isLab) return "hybrid";
  if (isLab) return "lab";
  return "office";
}
